export default __webpack_public_path__ + "static/media/icon-login-input-view.e1b76c3b.svg";